// import * as Sentry from '@sentry/react';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import { AppBase } from '../components/custom/app/AppBase';
import { AppLayout } from '../components/custom/layouts/AppLayout';
import {
  managedFarmPageInfo,
  marketPricePageInfo,
  newProductPageInfo,
  ownTractorPageInfo,
  pageInfo,
  sellTractorPageInfo,
} from '../constants/pageInfo/pageInfo.constant';
import { AfterJoinPage } from '../pages/Auth/Join/AfterJoinPage/AfterJoinPage';
import { JoinCompletePage } from '../pages/Auth/Join/JoinCompletePage/JoinCompletePage';
import { JoinProcessAgreementPage } from '../pages/Auth/Join/JoinProcess/JoinProcessAgreementPage/JoinProcessAgreementPage';
import { JoinProcessBusinessNamePage } from '../pages/Auth/Join/JoinProcess/JoinProcessBusinessNamePage/JoinProcessBusinessNamePage';
import { JoinProcessBusinessTypePage } from '../pages/Auth/Join/JoinProcess/JoinProcessBusinessTypePage/JoinProcessBusinessTypePage';
import { JoinProcessCropNamePage } from '../pages/Auth/Join/JoinProcess/JoinProcessCropNamePage/JoinProcessCropNamePage';
import { JoinProcessCropTypePage } from '../pages/Auth/Join/JoinProcess/JoinProcessCropTypePage/JoinProcessCropTypePage';
import { JoinProcessJobDetailPage } from '../pages/Auth/Join/JoinProcess/JoinProcessJobDetailPage/JoinProcessJobDetailPage';
import { JoinProcessJobPage } from '../pages/Auth/Join/JoinProcess/JoinProcessJobPage/JoinProcessJobPage';
import { JoinProcessReasonPage } from '../pages/Auth/Join/JoinProcess/JoinProcessReasonPage/JoinProcessReasonPage';
import { JoinProcessRegionPage } from '../pages/Auth/Join/JoinProcess/JoinProcessRegionPage/JoinProcessRegionPage';
import { JoinProcessTractorOwnCheckPage } from '../pages/Auth/Join/JoinProcess/JoinProcessTractorOwnCheckPage/JoinProcessTractorOwnCheckPage';
import { JoinProcessTractorWantBuyCheckPage } from '../pages/Auth/Join/JoinProcess/JoinProcessTractorWantBuyCheckPage/JoinProcessTractorWantBuyCheckPage';
import { AfterLoginPage } from '../pages/Auth/Login/AfterLoginPage/AfterLoginPage';
import { OAuthLoginPage } from '../pages/Auth/Login/OAuthLoginPage/OAuthLoginPage';
import { OAuthLoginResultPage } from '../pages/Auth/Login/OAuthLoginResultPage/OAuthLoginResultPage';
import { LogoutPage } from '../pages/Auth/Logout/LogoutPage/OAuthLogoutPage';
import { CropTrendsDetailPage } from '../pages/CropTrends/CropTrendsDetailPage/CropTrendsDetailPage';
import { CropTrendsListPage } from '../pages/CropTrends/CropTrendsListPage/CropTrendsList';
import { HomePage } from '../pages/Home/HomePage/HomePage';
import { InfoDetailPage } from '../pages/Info/InfoDetailPage/InfoDetailPage';
import { InfoListPage } from '../pages/Info/InfoListPage/InfoListPage';
import { ManagedFarmEntryPage } from '../pages/ManagedFarm/ManagedFarmEntryPage/ManagedFarmEntryPage';
import { ManagedFarmFieldMapPage } from '../pages/ManagedFarm/ManagedFarmFieldMapPage/ManagedFarmFieldMapPage';
import { ManagedFarmFormFieldOwnerPage } from '../pages/ManagedFarm/ManagedFarmForm/ManagedFarmFormFieldOwnerPage/ManagedFarmFormFieldOwnerPage';
import { ManagedFarmFormTaskCheckpointPage } from '../pages/ManagedFarm/ManagedFarmForm/ManagedFarmFormTaskCheckpointPage/ManagedFarmFormTaskCheckpointPage';
import { ManagedFarmFormTaskSchedulePage } from '../pages/ManagedFarm/ManagedFarmForm/ManagedFarmFormTaskSchedulePage/ManagedFarmFormTaskSchedulePage';
import { ManagedFarmFormTaskTypePage } from '../pages/ManagedFarm/ManagedFarmForm/ManagedFarmFormTaskTypePage/ManagedFarmFormTaskTypePage';
import { ManagedFarmMyTaskPage } from '../pages/ManagedFarm/ManagedFarmMyTaskPage/ManagedFarmMyTaskPage';
import { ManagedFarmSearchFieldPage } from '../pages/ManagedFarm/ManagedFarmSearchFieldPage/ManagedFarmSearchFieldPage';
import { ManagedFarmTaskDetailPage } from '../pages/ManagedFarm/ManagedFarmTaskDetailPage/ManagedFarmTaskDetailPage';
import { MarketPriceDetailPage } from '../pages/MarketPrice/MarketPriceDetailPage/MarketPriceDetailPage';
import { MarketPriceListPage } from '../pages/MarketPrice/MarketPriceListPage/MarketPriceListPage';
import { MarketPriceSearchPage } from '../pages/MarketPrice/MarketPriceSearchPage/MarketPriceSearchPage';
import { MarketPriceSearchResultPage } from '../pages/MarketPrice/MarketPriceSearchResultPage/MarketPriceSearchResultPage';
import { MyInfoAlarmSettingPage } from '../pages/MyInfo/MyInfoAlarmSettingPage/MyInfoAlarmSettingPage';
import { MyInfoDeleteAccountPage } from '../pages/MyInfo/MyInfoDeleteAccountPage/MyInfoDeleteAccountPage';
import { MyInfoEditProfilePage } from '../pages/MyInfo/MyInfoEditProfilePage/MyInfoEditProfilePage';
import { MyInfoMainPage } from '../pages/MyInfo/MyInfoMainPage/MyInfoMainPage';
import { MyInfoOwnTractorDetailPage } from '../pages/MyInfo/MyInfoOwnTractorDetailPage/MyInfoOwnTractorDetailPage';
import { MyInfoOwnTractorListPage } from '../pages/MyInfo/MyInfoOwnTractorListPage/MyInfoOwnTractorListPage';
import MyInfoPokeListPage from '../pages/MyInfo/MyInfoPokeListPage/MyInfoPokeListPage';
import { MyInfoSellTractorListPage } from '../pages/MyInfo/MyInfoSellTractorListPage/MyInfoSellTractorListPage';
import { NewProductDetailPage } from '../pages/NewProduct/NewProductDetailPage/NewProductDetailPage';
import { NewProductListPage } from '../pages/NewProduct/NewProductListPage/NewProductListPage';
import { DirectDealDetailPage } from '../pages/OpenMarket/DirectDeal/DirectDealDetailPage/DirectDealDetailPage';
import { DirectDealListPage } from '../pages/OpenMarket/DirectDeal/DirectDealtListPage/DirectDealListPage';
import { OpenMarketSearchPage } from '../pages/OpenMarket/OpenMarketSearchPage/OpenMarketSearchPage';
import { OpenMarketSearchResultPage } from '../pages/OpenMarket/OpenMarketSearchResultPage/OpenMarketSearchResultPage';
import { TractorPokingDetailPage } from '../pages/OpenMarket/TractorPoking/TractorPokingDetailPage/TractorPokingDetailPage';
import { TractorPokingListPage } from '../pages/OpenMarket/TractorPoking/TractorPokingListPage/TractorPokingListPage';
import { PluvaAutoLandingPage } from '../pages/PluvaAutoLandingPage/PluvaAutoLandingPage';
import { ProductDetailPage } from '../pages/Product/ProductDetailPage/ProductDetailPage';
import { ProductListPage } from '../pages/Product/ProductListPage/ProductListPage';
import { ProductOptionPage } from '../pages/Product/ProductOptionPage/ProductOptionPage';
import { OwnTractorSurveyCompletePage } from '../pages/Survey/OwnTractorSurvey/OwnTractorSurveyCompletePage/OwnTractorSurveyCompletePage';
import { OwnTractorSurveyEntryPage } from '../pages/Survey/OwnTractorSurvey/OwnTractorSurveyEntryPage/OwnTractorSurveyEntryPage';
import { OwnTractorSurveyImageUploadPage } from '../pages/Survey/OwnTractorSurvey/OwnTractorSurveyImageUploadPage/OwnTractorSurveyImageUploadPage';
import { OwnTractorSurveyMarketPricePage } from '../pages/Survey/OwnTractorSurvey/OwnTractorSurveyMarketPricePage/OwnTractorSurveyMarketPricePage';
import { OwnTractorSurveyRequiredInputOverviewPage } from '../pages/Survey/OwnTractorSurvey/OwnTractorSurveyRequiredInputOverviewPage/OwnTractorSurveyRequiredInputOverviewPage';
import { SellTractorSurveyEntryPage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyEntryPage/SellTractorSurveyEntryPage';
import { SellTractorSurveyHopeSellingPricePage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyHopeSellingPricePage/SellTractorSurveyHopeSellingPricePage';
import { SellTractorSurveyLocationPage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyLocationPage/SellTractorSurveyLocationPage';
import { SellTractorSurveyOptionPage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyOptionPage/SellTractorSurveyOptionPage';
import { SellTractorSurveyRequiredInputOverviewPage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyRequiredInputOverviewPage/SellTractorSurveyRequiredInputOverviewPage';
import { SellTractorSurveyTireConditionPage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyTireConditionPage/SellTractorSurveyTireConditionPage';
import { SellTractorSurveyTractorExtraInfo1Page } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyTractorExtraInfo1Page/SellTractorSurveyTractorExtraInfo1Page';
import { SellTractorSurveyTractorExtraInfo2Page } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyTractorExtraInfo2Page/SellTractorSurveyTractorExtraInfo2Page';
import { SellTractorSurveyTractorRequiredImagePage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyTractorRequiredImagePage/SellTractorSurveyTractorRequiredImagePage';
import { SellTractorSurveyWorkingMachinePage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyWorkingMachinePage/SellTractorSurveyWorkingMachinePage';
import { EventPage202402 } from '../pages/etc/EventPage/EventPage202402';
import { EventPage202405 } from '../pages/etc/EventPage/EventPage202405';
import { PluvaAutoBusinessPage } from '../pages/etc/NoLayoutPages/PluvaAutoBusinessPage/PluvaAutoBusinessPage';
import { PluvaAutoCustomerServicePage } from '../pages/etc/NoLayoutPages/PluvaAutoCustomerServicePage/PluvaAutoCustomerServicePage';
import { NotFoundPage } from '../pages/etc/NotFoundPage/NotFoundPage';
import { NoticePage } from '../pages/etc/NoticePage/NoticePage';
import { TermsOfUseListPage } from '../pages/etc/TermsOfUse/TermsOfUseListPage';
import { LoggedInUserOnly } from './LoggedInUserOnly';

// const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);

export const router = createBrowserRouter([
  {
    element: <AppBase />,
    children: [
      { path: pageInfo.pluvaAutoBusinessPage.path, element: <PluvaAutoBusinessPage /> },
      { path: pageInfo.pluvaAutoCustomerServicePage.path, element: <PluvaAutoCustomerServicePage /> },
      {
        element: <AppLayout />,
        children: [
          // 2024-02 갑진년 이벤트
          { path: '/event-2024-02', element: <EventPage202402 /> },

          // 2024-05 이앙기 프로모션
          { path: '/event-2024-05', element: <EventPage202405 /> },

          // root
          { path: '/', element: <Navigate to={'/home'} replace /> },

          // home
          { path: pageInfo.homePage.path, element: <HomePage /> },

          // info
          {
            path: pageInfo.infoListPage.path,
            element: <InfoListPage />,
          },
          {
            path: `${pageInfo.infoDetailPage.path}/:informationId`,
            element: <InfoDetailPage />,
          },

          // products
          {
            path: pageInfo.productListPage.path,
            element: <ProductListPage />,
          },
          {
            path: `${pageInfo.productDetailPage.path}/:productId`,
            element: <ProductDetailPage />,
          },
          {
            path: `${pageInfo.productOptionPage.path}/:productId`,
            element: <ProductOptionPage />,
          },

          // new-products
          {
            path: newProductPageInfo.listPage.path,
            element: <NewProductListPage />,
          },
          {
            path: `${newProductPageInfo.detailPage.path}/:productId`,
            element: <NewProductDetailPage />,
          },

          // open-market
          {
            path: pageInfo.openMarketListPage.path,
            element: <DirectDealListPage />,
          },
          {
            path: pageInfo.openMarketSearchPage.path,
            element: <OpenMarketSearchPage />,
          },
          {
            path: pageInfo.openMarketSearchResultPage.path,
            element: <OpenMarketSearchResultPage />,
          },
          {
            path: `${pageInfo.openMarketDetailPage.path}/:productId`,
            element: <DirectDealDetailPage />,
          },
          {
            path: pageInfo.tractorPokingListPage.path,
            element: <TractorPokingListPage />,
          },
          {
            path: `${pageInfo.tractorPokingDetailPage.path}/:productId`,
            element: <TractorPokingDetailPage />,
          },
          // myinfo
          {
            path: pageInfo.myInfoPage.path,
            element: (
              <LoggedInUserOnly>
                <MyInfoMainPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: pageInfo.myInfoAlarmSettingPage.path,
            element: (
              <LoggedInUserOnly>
                <MyInfoAlarmSettingPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: pageInfo.myInfoEditProfilePage.path,
            element: (
              <LoggedInUserOnly>
                <MyInfoEditProfilePage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: pageInfo.myInfoOwnTractorListPage.path,
            element: (
              <LoggedInUserOnly>
                <MyInfoOwnTractorListPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: `${pageInfo.myInfoOwnTractorDetailPage.path}/:tractorId`,
            element: (
              <LoggedInUserOnly>
                <MyInfoOwnTractorDetailPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: pageInfo.myInfoSellTractorListPage.path,
            element: (
              <LoggedInUserOnly>
                <MyInfoSellTractorListPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: pageInfo.myInfoPokeListPage.path,
            element: (
              <LoggedInUserOnly>
                <MyInfoPokeListPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: pageInfo.deleteAccountPage.path,
            element: (
              <LoggedInUserOnly>
                <MyInfoDeleteAccountPage />
              </LoggedInUserOnly>
            ),
          },

          // Auth
          {
            path: pageInfo.loginPage.path,
            element: <OAuthLoginPage />,
          },
          {
            path: '/oauth/login-result',
            element: <OAuthLoginResultPage />,
          },
          {
            path: '/after-join',
            element: <AfterJoinPage />,
          },
          {
            path: '/after-login',
            element: <AfterLoginPage />,
          },
          {
            path: '/logout',
            element: <LogoutPage />,
          },

          // Join Process
          {
            path: '/join-process/agreement',
            element: <JoinProcessAgreementPage />,
          },
          {
            path: '/join-process/region',
            element: <JoinProcessRegionPage />,
          },
          {
            path: '/join-process/job',
            element: <JoinProcessJobPage />,
          },
          {
            path: '/join-process/crop-type',
            element: <JoinProcessCropTypePage />,
          },
          {
            path: '/join-process/crop-name',
            element: <JoinProcessCropNamePage />,
          },
          {
            path: '/join-process/reason',
            element: <JoinProcessReasonPage />,
          },
          {
            path: '/join-process/tractor-own-check',
            element: <JoinProcessTractorOwnCheckPage />,
          },
          {
            path: '/join-process/tractor-want-buy-check',
            element: <JoinProcessTractorWantBuyCheckPage />,
          },
          {
            path: '/join-process/business-name',
            element: <JoinProcessBusinessNamePage />,
          },
          {
            path: '/join-process/business-type',
            element: <JoinProcessBusinessTypePage />,
          },
          {
            path: '/join-process/job-detail',
            element: <JoinProcessJobDetailPage />,
          },

          // terms-of-use
          {
            path: '/terms-of-use/list',
            element: <TermsOfUseListPage />,
          },

          // survey
          {
            path: ownTractorPageInfo.entryPage.path,
            element: <OwnTractorSurveyEntryPage />,
          },
          {
            path: ownTractorPageInfo.overviewPage.path,
            element: <OwnTractorSurveyRequiredInputOverviewPage />,
          },
          {
            path: ownTractorPageInfo.marketPricePage.path,
            element: <OwnTractorSurveyMarketPricePage />,
          },
          {
            path: ownTractorPageInfo.completePage.path,
            element: <OwnTractorSurveyCompletePage />,
          },
          {
            path: ownTractorPageInfo.imageUploadPage.path,
            element: <OwnTractorSurveyImageUploadPage />,
          },
          {
            path: '/survey/entry/sell-tractor',
            element: <SellTractorSurveyEntryPage />,
          },
          {
            path: sellTractorPageInfo.overviewPage.path,
            element: <SellTractorSurveyRequiredInputOverviewPage />,
          },
          {
            path: sellTractorPageInfo.locationPage.path,
            element: <SellTractorSurveyLocationPage />,
          },
          {
            path: sellTractorPageInfo.optionPage.path,
            element: <SellTractorSurveyOptionPage />,
          },
          {
            path: sellTractorPageInfo.workingMachinePage.path,
            element: <SellTractorSurveyWorkingMachinePage />,
          },
          {
            path: sellTractorPageInfo.extraInfo1Page.path,
            element: <SellTractorSurveyTractorExtraInfo1Page />,
          },
          {
            path: sellTractorPageInfo.tireConditionPage.path,
            element: <SellTractorSurveyTireConditionPage />,
          },
          {
            path: sellTractorPageInfo.requireImagePage.path,
            element: <SellTractorSurveyTractorRequiredImagePage />,
          },
          {
            path: sellTractorPageInfo.pricePage.path,
            element: <SellTractorSurveyHopeSellingPricePage />,
          },
          {
            path: sellTractorPageInfo.extraInfo2Page.path,
            element: <SellTractorSurveyTractorExtraInfo2Page />,
          },

          // Pluva Auto Landing
          {
            path: pageInfo.pluvaAutoPage.path,
            element: <PluvaAutoLandingPage />,
          },

          // etc
          {
            path: '/noti',
            element: <NoticePage />,
          },
          {
            path: '/join-complete',
            element: (
              <LoggedInUserOnly>
                <JoinCompletePage />
              </LoggedInUserOnly>
            ),
          },

          // not found
          {
            path: '/not-found',
            element: <NotFoundPage />,
          },

          // TODO : 앱 다운로드 페이지 스펙이 다시 정해진 후 재구현 https://gint-team.atlassian.net/browse/PVM-1700
          // {
          //   path: pageInfo.downloadAppPage.path,
          //   element: <DownloadAppPageFor2024JulyJohnDeere />,
          // },

          // market-price
          {
            path: marketPricePageInfo.listPage.path,
            element: <MarketPriceListPage />,
          },
          // 설명 : 더 이상 미사용되는 URL 이지만, 이미 유저에게 노출된 이력이 있으므로 replace 처리합니다.
          {
            path: marketPricePageInfo.entryPage.path,
            element: <Navigate to={marketPricePageInfo.listPage.path} replace />,
          },
          {
            path: marketPricePageInfo.searchPage.path,
            element: <MarketPriceSearchPage />,
          },
          {
            path: marketPricePageInfo.searchResultPage.path,
            element: <MarketPriceSearchResultPage />,
          },
          {
            path: `${marketPricePageInfo.detailPage.path}/:machineId`,
            element: <MarketPriceDetailPage />,
          },
          {
            path: `${marketPricePageInfo.detailPage.path}/:machineId`,
            element: <MarketPriceDetailPage />,
          },

          // crop-trends
          {
            path: pageInfo.cropTrendsListPage.path,
            element: <CropTrendsListPage />,
          },
          {
            path: `${pageInfo.cropTrendsDetailPage.path}`,
            element: <CropTrendsDetailPage />,
          },

          // managed-farm
          {
            path: managedFarmPageInfo.entryPage.path,
            element: <ManagedFarmEntryPage />,
          },
          {
            path: managedFarmPageInfo.searchFieldPage.path,
            element: <ManagedFarmSearchFieldPage />,
          },
          {
            path: managedFarmPageInfo.fieldMapPage.path,
            element: <ManagedFarmFieldMapPage />,
          },
          {
            path: managedFarmPageInfo.formFieldOwnerPage.path,
            element: <ManagedFarmFormFieldOwnerPage />,
          },
          {
            path: managedFarmPageInfo.formTaskTypePage.path,
            element: <ManagedFarmFormTaskTypePage />,
          },
          {
            path: managedFarmPageInfo.formTaskSchedulePage.path,
            element: <ManagedFarmFormTaskSchedulePage />,
          },
          {
            path: managedFarmPageInfo.formTaskCheckpointPage.path,
            element: <ManagedFarmFormTaskCheckpointPage />,
          },
          {
            path: `${managedFarmPageInfo.taskDetailPage.path}/:taskId`,
            element: <ManagedFarmTaskDetailPage />,
          },
          {
            path: `${managedFarmPageInfo.myTaskPage.path}`,
            element: <ManagedFarmMyTaskPage />,
          },

          // rest
          {
            path: '*',
            element: <Navigate to={`/not-found?from=${window.location.href}`} replace />,
          },
        ],
      },
    ],
  },
]);
